import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-close-button',
  standalone: true,
  templateUrl: './close-button.component.html',
  styleUrls: ['./close-button.component.scss'],
  imports: [MDBBootstrapModulesPro]
})
export class CloseButtonComponent implements OnInit {

  @Output("callbackFunction") callbackFunction: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  callback(): void {
    console.log('close window called')
    this.callbackFunction.emit();
  }
}
